import React from "react";
import styles from "./Status-badge.module.css";

interface StatusBadgeProps {
  children: React.ReactNode;
  type?: string
  scale?: number;
  fontSize?: string;
  circleSize?: string;
}

function StatusBadge({
  children,
  type,
  scale = 1,
  fontSize = "16px",
  circleSize = "8px",
}: StatusBadgeProps) {
  // Маппинг классов и цветов для каждого типа статуса
  const statusConfig: Record<string, { badgeClass: string; circleClass: string; circleColor: string }> = {
    active: {
      badgeClass: `${styles.badge} ${styles["badge-active"]}`,
      circleClass: `${styles.circle} ${styles["circle-active"]}`,
      circleColor: "#30bb67",
    },
    test: {
      badgeClass: `${styles.badge} ${styles["badge-test"]}`,
      circleClass: `${styles.circle} ${styles["circle-test"]}`,
      circleColor: "#ffa722",
    },
    error: {
      badgeClass: `${styles.badge} ${styles["badge-error"]}`,
      circleClass: `${styles.circle} ${styles["circle-error"]}`,
      circleColor: "#d83a3a",
    },
    reprocessing: {
      badgeClass: `${styles.badge} ${styles["badge-reprocessing"]}`,
      circleClass: `${styles.circle} ${styles["circle-reprocessing"]}`,
      circleColor: "#3498db", // Голубой цвет
    },
    default: {
      badgeClass: styles.badge,
      circleClass: styles.circle,
      circleColor: "#678aa1",
    },
  };

  const { badgeClass, circleClass, circleColor } = statusConfig[type || "default"];

  const circleStyle = {
    width: circleSize,
    height: circleSize,
    backgroundColor: circleColor,
  };

  const style = {
    transform: `scale(${scale})`,
    fontSize, // Размер шрифта из props
  };

  return (
    <div className={badgeClass} style={style}>
      <div className={circleClass} style={circleStyle}></div>
      {children}
    </div>
  );
}

export default StatusBadge;
